import { Stack } from "@altimateai/lego";
import classes from "../summary.module.scss";
import OpportunitiesList from "./OpportunitiesList";
import dayjs from "dayjs";
import { NativeSelect, Typography } from "@altimateai/lego";

const Opportunities = ({ instanceId }: { instanceId: string }) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  return (
    <section id="opportunities">
      <Stack className="al-justify-between">
        <Typography variant="section-heading">Opportunities</Typography>
        <Stack className="al-items-center">
          <Stack>
            <div>{dayjs().subtract(28, "day").toDate().toLocaleDateString("en-US", options)}</div>
            <div>-</div>
            <div>{dayjs().toDate()?.toLocaleDateString("en-US", options)}</div>
          </Stack>
          <NativeSelect
            variant="ghost"
            placeholder="Last 28 days"
            options={[
              {
                label: "Last 28 days",
                value: "Last 28 days",
              },
            ]}
          />
        </Stack>
      </Stack>
      <p className={classes.caption}>
        This section shows key areas in which major cost saving opportunities are present
      </p>
      <OpportunitiesList instanceId={instanceId} />
    </section>
  );
};

export default Opportunities;
